import { Component, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Router } from "@angular/router";
import { CommonDataService } from "./../common-data.service";
import { AccessGroupService } from "./../access-group.service";
import { environment } from "../../../environments/environment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Location } from "@angular/common";
import { Store } from "@ngrx/store";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { EXCLUDED_LEARNER_MAP_TITLES } from "../../service/learner-map-titles";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})

export class DashboardComponent implements OnInit, OnDestroy {
  public nav: any;
  public menu_items: any;
  public profile: any = null;
  public a_profile: any;
  public picture_url: string;
  public p_url: any;
  public env;
  public dashboard;
  public lm;
  public Video: number;
  public modal: any;
  main_menu: any;
  imgSrc: string;
  certification: string;
  // Navigational Items
  assessment_admin: string = environment.assessment_admin;
  features_admin: string = environment.features_admin;
  brand_identity: any;
  public member_id: string;
  current_lm: any;
  allmaps: any;
  current_mapExist: boolean = false;
  email_verified: string;
  reset_pswrd: string;
  mail_sent: boolean = false;
  pswrd_sent: boolean = false;
  mail_resent: boolean = false;
  pswrd_resent: boolean = false;
  verify: boolean = false;
  email: string;
  user: any;
  assessment_img: string;
  profileNgrx$;
  ngrxAccessGroup: any;
  ngrxError$: any;
  error;
  havepf: boolean = true;
  image: string = "";
  placeholderImage = 'assets/images/learner-map-placeholder.svg';
  admin: boolean = false;
  accountNgrx$;

  // New UI state properties
  greeting: string = '';
  isLoading: boolean = true;
  showProfileError: boolean = false;

  public constructor(
    public location: Location,
    public http: HttpClient,
    private router: Router,
    public service: CommonDataService,
    public accessgroup: AccessGroupService,
    private modalService: NgbModal,
    public store: Store<any>,
    public oidcSecurityService: OidcSecurityService,
    private renderer: Renderer2
  ) {
    this.nav = document.querySelector("nav.navbar");
    this.user = {};
  }

  public ngOnInit() {
    this.env = environment;
    this.setGreeting();
    this.accountNgrx$ = this.store.select<any>((state) => state.profile?.account);
    this.accountNgrx$.subscribe(message => {
      if (message?.primary_role == 'owner') {
        this.admin = true;
      }
      this.setCurrentLearnerMap(message?.assigned_learner_maps);
    });
    this.ngrxAccessGroup = this.store.select<any>((state) => state.profile.accessGroupData);
    this.ngrxError$ = this.store.select<any>((state) => state.profile.error);
    this.Video = 0;
    this.ngrxError$.subscribe(err => {
      if (err?.status == 503) {
        this.error = err;
      }
      if (err?.status == 412) {
        this.email = localStorage.getItem("email");
        if (err.error.errors == "Reset password required") {
          this.reset_pswrd = "false";
        }
        if (err.error.errors == "Email verification required") {
          this.email_verified = "false";
        }
      }
    });
    let isAttachedToCustomer = false;
    let productsLoaded = false;
    this.ngrxAccessGroup.subscribe((message) => {
      if (message && Object.keys(message).length) {
          if (!productsLoaded) {
            productsLoaded = true;
            this.http.get(`${this.env.assessment_admin}api/v1/public/products.json`).subscribe(data => {
              this.assessment_img = data['products'][0]?.image_url;
            });
          }

          this.showProfileError = false;
          this.renderer.addClass(this.nav, 'white-bg');
          this.email = localStorage.getItem("email");
          if (localStorage.getItem("FS login") == "true") {
            localStorage.setItem("FS login", "false");
          }

          if (localStorage.getItem("cart_id") && !isAttachedToCustomer) {
            isAttachedToCustomer = true;
            var cartId = localStorage.getItem("cart_id");
            this.http
              .get(
                `${environment.assessment_admin}api/v1/carts/` +
                  cartId +
                  `/attach_to_customer`
              )
              .subscribe(
                (data) => {
                  this.router.navigate(["/custom-store/cart"]);
                  localStorage.removeItem("cart_id");
                },
                (error) => {
                  console.log("oops", error);
                }
              );
          }

          this.getPfData();
          this.email_verified = "true";
          this.reset_pswrd = "true";
          // allmaps is built from assigned_learner_maps in setCurrentLearnerMap(),
          // not from main_menu.learner_maps — see that method for why.
          this.dashboard = message["main_menu"]?.dashboard;
          this.main_menu = message["main_menu"];
          this.lm = message["main_menu"]?.learner_maps;
          this.a_profile = message["main_menu"]?.collaboration_profile;
        }
      },
      (err) => {
        // Log errors if any
        if (err.status == 412) {
          this.email = localStorage.getItem("email");
          if (err.error.errors == "Reset password required") {
            this.reset_pswrd = "false";
          }
          if (err.error.errors == "Email verification required") {
            this.email_verified = "false";
          }
        }
      }
    );
  }

  private setGreeting() {
    const hour = new Date().getHours();
    if (hour < 12) {
      this.greeting = 'Good morning';
    } else if (hour < 17) {
      this.greeting = 'Good afternoon';
    } else {
      this.greeting = 'Good evening';
    }
  }

  // get profile data from store
  public getPfData() {
    this.profileNgrx$ = this.store.select<any>((state) => state.profile?.account.default_profile);
    this.profileNgrx$.subscribe(
        (message) => {
          this.brand_identity = message?.source_owner?.collaboration_identity;
          if (message && message?.profile_title) {
            this.havepf = true;
            this.email_verified = "true";
            this.reset_pswrd = "true";
            this.profile = message;
            if (localStorage.getItem("impersonation") == "true") {
              localStorage.setItem("email", this.profile.email);
            }
            if (this.profile?.identity?.first_name != "" && this.profile?.identity?.first_name != null) {
              this.renderer.addClass(document.body, 'pace-done');
            }
            this.isLoading = false;
          } else {
            this.email_verified = "true";
            this.reset_pswrd = "true";
            this.showProfileError = true;
            this.store.select<any>((state) => state.profile.isLoading).subscribe((rslt) => {
              if (rslt == false) {
                setTimeout(() => {
                  this.isLoading = false;
                  this.havepf = false;
                }, 100);
              } else {
                this.isLoading = false;
              }
            });
          }
        },
        (err) => {
          // Log errors if any
          if (err.status == 412) {
            console.warn(err);
            this.email = localStorage.getItem("email");
            if (err.error.errors == "Reset password required") {
              this.reset_pswrd = "false";
            }
            if (err.error.errors == "Email verification required") {
              this.email_verified = "false";
            }
            this.isLoading = false;
          }
        }
      );
  }

  onImgError(event: Event) {
    const img = event.target as HTMLImageElement;
    if (img && img.src !== this.placeholderImage) {
      img.src = this.placeholderImage;
    }
  }

  /**
   * Builds the list behind the "Current Learner Map" card from
   * `assigned_learner_maps` — the source the side nav and the /learner-maps
   * listing already use. This card previously read `main_menu.learner_maps`,
   * which nests its entries by category (`training` -> `mindset`), so the flat
   * `[i].title` lookup never matched and the card silently never rendered.
   *
   * The card takes the *last* element, so the ascending sort by priority is kept
   * deliberately: "current" means highest priority, as it always has.
   *
   * Caveat: `assigned_learner_maps` entries carry only id/title/value — the API
   * does not send `priority` on this payload, though `main_menu.learner_maps`
   * did. So the sort is currently a no-op and "current" degrades to the last map
   * in the order the API returns. Missing priorities are coerced to 0 rather
   * than left as NaN, which would make the comparator — and so the card —
   * non-deterministic; with equal keys the sort is stable and API order is kept.
   */
  private setCurrentLearnerMap(assigned: any): void {
    this.allmaps = [];
    if (!assigned) { return; }
    const entries: [string, any][] = Array.isArray(assigned)
      ? assigned.map((item: any) => [item.id || item.value, item])
      : Object.entries(assigned);
    entries.forEach(([key, map]) => {
      if (map?.title && !EXCLUDED_LEARNER_MAP_TITLES.includes(map.title)) {
        this.allmaps.push([key, { ...map, value: map.value || map.id || key }]);
      }
    });
    this.allmaps.sort((a, b) => (parseInt(a[1].priority, 10) || 0) - (parseInt(b[1].priority, 10) || 0));
  }

  public ngOnDestroy(): any {
    this.nav.classList.remove("white-bg");
  }
  public closebox = function () {
    var ibox = $(".ibox-tools").closest("div.ibox");
    ibox.remove();
  };
  public showhide = function () {
    var ibox = $(".ibox-tools").closest("div.ibox");
    var icon = $(".ibox-tools").find("i:first");
    var content = ibox.find("div.ibox-content");
    content.slideToggle(200);
    // Toggle icon from up to down
    icon.toggleClass("fa-chevron-up").toggleClass("fa-chevron-down");
    ibox.toggleClass("").toggleClass("border-bottom");
    setTimeout(function () {
      ibox.resize();
      ibox.find("[id^=map-]").resize();
    }, 50);
  };

  public video() {
    this.Video = 1;
  }

  closeDialogR() {
    $("button.close").trigger("click");
    this.router.navigate(["/branding"]);
  }

    public getIdentity() {
        this.member_id = localStorage.getItem("member_id");
        this.http
            .get(
                `${environment.profileURL}/api/v1/members/` + this.member_id + `.json`
            )
            .subscribe(
                (result) => {
                    console.log(result);
                    this.brand_identity = result["member"]["brand_identity"];
                },
                (error) => console.log("oops", error)
            );
    }

  public sendMail() {
    this.verify = true;
    this.http
      .get(
        `${environment.profileURL}/api/v1/users/send_verification_email.json`
      )
      .subscribe(
        (result) => {
          console.log(result);
          this.mail_sent = true;
          this.verify = false;
        },
        (error) => {
          console.log("oops", error);
          this.verify = false;
        }
      );
  }

  public resendMail() {
    this.verify = true;
    this.http
      .get(
        `${environment.profileURL}/api/v1/users/send_verification_email.json`
      )
      .subscribe(
        (result) => {
          console.log(result);
          this.mail_resent = true;
          this.verify = false;
        },
        (error) => {
          console.log("oops", error);
          this.verify = false;
        }
      );
  }

  public sendPswrdReset() {
    this.verify = true;
    this.http
      .get(
        `${environment.profileURL}/api/v1/users/send_reset_password_email.json`
      )
      .subscribe(
        (result) => {
          console.log(result);
          this.pswrd_sent = true;
          this.verify = false;
        },
        (error) => {
          console.log("oops", error);
          this.verify = false;
        }
      );
  }

  public resendPswrd() {
    this.verify = true;
    this.http
      .get(
        `${environment.profileURL}/api/v1/users/send_reset_password_email.json`
      )
      .subscribe(
        (result) => {
          console.log(result);
          this.pswrd_resent = true;
          this.verify = false;
        },
        (error) => {
          console.log("oops", error);
          this.verify = false;
        }
      );
  }
}